import styled from 'styled-components';

import { Link } from '@xing-com/crate-core-router';
import { IconArrowDown } from '@xing-com/icons';
import { spaceXS, spaceXL, xdlColorText } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const Container = styled.div`
  display: flex;
  align-items: center;
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-bottom: ${spaceXL};

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;

export const StyledBodyCopy = styled(BodyCopy)`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const ArrowWrapper = styled.span`
  display: flex;
  margin: 0 ${spaceXS};
`;

export const StyledIconArrowDown = styled(IconArrowDown)`
  transform: rotate(-90deg);
`;

const linkStyles = `
  color: ${xdlColorText};
  overflow: hidden;
  
  &:first-child {
    overflow: initial;
  }
`;

export const StyledInternalLink = styled(Link)`
  ${linkStyles}
`;
export const StyledExternalLink = styled.a`
  ${linkStyles}
`;
